import React, { useEffect, useState } from 'react';
import { Header, Footer, LeftMenu } from '../commons/components';
import { EditPassword } from './components';
import { usePageSettingHeaderStore } from '../commons/stores';
// import { useAuthStore } from "../../auth/stores";
// import { useProfileStore } from "./store";
import { toast } from 'react-toastify';
import { isAuth, logout } from '../auth/actions';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

export default function Edit() {
  // const [state, actions] = useProfileStore();
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  // const [authState, authActions] = useAuthStore();
  // const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));

  useEffect(() => {
    document.title = `Change Passoword - Ubaform Admin`;
  }, []);

  let contentUi = <div className='loader-block' />;
  if (!isAuth().isLoading) {
    contentUi = (
      <React.Fragment>
        <EditPassword stateDetail={isAuth()} />
      </React.Fragment>
    );
  }

  // console.log(isAuth().result);

  // if (!user) {
  //   toast.error('Cannot load data user profile');
  // }

  return (
    <>
      {isAuth() ? (
        <div className='App'>
          <Header />
          {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}
          <main className='workspace'>
            <section className='breadcrumb lg:flex items-start'>
              <div className='flex items-center justify-between w-full'>
                <div>
                  {' '}
                  <h1>
                    Profile <b>{isAuth().name}</b>
                  </h1>
                </div>
                <div className='space-x-2'>
                  <Link to='/profile'>
                    <button className='border-2 border-primary py-2 px-3 rounded text-primary hover:bg-primary hover:text-white'>
                      Back to Profile
                    </button>
                  </Link>
                  <button className='bg-primary border-2 border-primary py-2 px-3 rounded text-white '>
                    Save Changes
                  </button>
                </div>
              </div>
            </section>
            {contentUi}
            <Footer />
          </main>
        </div>
      ) : (
        <Redirect to='/auth' />
      )}
    </>
  );
}
